
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["prt-icon prt-option-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 85 72.4"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Ebene_2","data-name":"Ebene 2"}},[_c('g',{attrs:{"id":"Ebene_1-2","data-name":"Ebene 1"}},[_c('path',{attrs:{"fill":"#9c9c9e","d":"M.1 70.7h75.6v1.7H.1z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M39.3 58.4H16.4v-17h22.8v17zm36.4 10.1V14.8H9.3v53.8h36.4V40h21.4v28.6z"}}),_c('path',{staticClass:"prt-icon-color",attrs:{"fill":"#008cc7","d":"M47.2 41.4h18.5v27.2H47.2z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M9.3 0h66.3v6.9H9.3zM27.4 9.4l-4.3 24.5h12.1l1.6-24.5h-9.4zM9.4 9.4L0 33.9h10.1l7.2-24.5H9.4zM67.7 9.4l7.2 24.5H85L75.6 9.4h-7.9zM48.2 9.4l1.6 24.5h12.1L57.6 9.4h-9.4z"}}),_c('path',{staticClass:"cls-4",attrs:{"d":"M74.9 33.9L67.7 9.4H57.6l4.3 24.5h13zM23.1 33.9l4.3-24.5H17.3l-7.2 24.5h13zM36.8 9.4l-1.6 24.5h14.6L48.2 9.4H36.8z"}})])])])
          )
        }
      }
    